export interface LocaleSort<T> {
  sort(): T[];
}

export type BasicLocaleSortRequirement = {
  country_name: string;
  language_code: string;
};

export class AlphabeticalLocaleSorter<T extends BasicLocaleSortRequirement>
  implements LocaleSort<T>
{
  constructor(private readonly _list: T[]) {}

  public sort(): T[] {
    return this._list.sort((a, b) => {
      if (a.country_name !== b.country_name) {
        return this._compare(a.country_name, b.country_name);
      }

      if (a.language_code !== b.language_code) {
        return this._compare(a.language_code, b.language_code);
      }

      return 0;
    });
  }

  private _compare(a: string, b: string): number {
    return a.localeCompare(b);
  }
}

export class PriorityBasedLocaleSorter<T extends BasicLocaleSortRequirement>
  implements LocaleSort<T>
{
  constructor(
    private readonly _list: T[],
    private readonly _countryName: string
  ) {}

  public sort(): T[] {
    return this._list.sort((a, b) => {
      if (b.country_name === this._countryName) {
        return 1;
      }

      if (a.country_name !== this._countryName) {
        return 1;
      }

      return -1;
    });
  }
}

export class LocaleSorter<T extends BasicLocaleSortRequirement>
  implements LocaleSort<T>
{
  constructor(private readonly _list: T[]) {}

  public sort(): T[] {
    const firstSetResult = new AlphabeticalLocaleSorter(this._list).sort();
    const secondSetResult = new PriorityBasedLocaleSorter(
      firstSetResult,
      'Canada'
    ).sort();
    return new PriorityBasedLocaleSorter(
      secondSetResult,
      'United States'
    ).sort();
  }
}
